<ng-container *transloco="let tloco; prefix: 'subscriptions.payment-methods'">
  <div>
    <label>{{ tloco('title') }}</label>
    <p class="text-steel-70">
      {{ tloco('summary') }}
    </p>
  </div>
  @for (paymentMethod of paymentMethods; track paymentMethod) {
    <div
      class="mb-4 flex flex-col flex-wrap rounded border border-steel-20 p-3 md:flex-row md:items-center md:justify-between"
      [class.border-blue-50!]="paymentMethod.isDefault"
      [class.border-warning-50!]="paymentMethod.card?.isExpired"
    >
      <div class="flex gap-4">
        @if (paymentMethod.card) {
          <img class="block h-12 w-14 flex-initial" [src]="paymentMethod.card.brand | paymentMethodIcon" [alt]="paymentMethod.card.brand" />
          <div class="flex-auto leading-normal">
            <strong>{{ paymentMethod.card.number }}</strong>
            <div [class.text-warning-50]="paymentMethod.card.isExpired">
              {{ tloco('card.expiry') }}
              {{ paymentMethod.card.expiryMonth | number: '2.0-0' }}/{{ paymentMethod.card.expiryYear }}
            </div>
          </div>
        }
        @if (paymentMethod.bankDetails) {
          <img alt="Direct Debit" class="block h-12 w-14 flex-initial" [src]="'directdebit' | paymentMethodIcon" />
          <div class="flex-auto leading-normal">
            <div>
              {{ tloco('bank.routing') }}
              <strong>{{ paymentMethod.bankDetails.routingNumber }}</strong>
            </div>
            <div>
              {{ tloco('bank.account') }}
              <strong>{{ paymentMethod.bankDetails.accountNumber }}</strong>
            </div>
          </div>
        }
      </div>
      <div class="flex items-center justify-end gap-3">
        @if (paymentMethod.isDefault) {
          <span class="rounded-3xl bg-blue-10 px-2 py-1 text-steel-100">{{ tloco('default') }}</span>
        } @else {
          @if (!paymentMethod.card?.isExpired) {
            <button type="button" (click)="makeDefault(paymentMethod)" mat-button color="primary">
              {{ tloco('make-default') }}
            </button>
          }
          <button type="button" (click)="removePaymentMethod(paymentMethod)" mat-icon-button color="primary">
            <rma-icon glyph="delete" />
          </button>
        }
      </div>
    </div>
  }

  @if (!paymentMethods?.length) {
    <div class="mb-4 flex justify-center rounded-md bg-steel-10 p-2">
      <span>{{ tloco('none') }}</span>
    </div>
  }

  <div class="flex justify-center md:justify-end">
    <button type="button" (click)="updatePaymentMethod()" mat-button color="primary">
      <rma-icon glyph="add" theme="primary" matButtonIcon />
      <span>{{ tloco('add') }}</span>
    </button>
  </div>
</ng-container>
